var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('span',{class:_vm.className},[_c('i',{class:this.icon}),_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('i',{class:_vm.className})
}
var staticRenderFns = []

export { render, staticRenderFns }